import api from "./client";

export async function listVariantDimensions() {
  const res = await api.get("/variant-dimensions");
  return res.data.data.items;
}

export async function createVariantDimension(payload) {
  const res = await api.post("/variant-dimensions", payload);
  return res.data.data;
}

export async function updateVariantDimension(id, payload) {
  const res = await api.put(`/variant-dimensions/${id}`, payload);
  return res.data.data;
}

export async function deleteVariantDimension(id) {
  const res = await api.delete(`/variant-dimensions/${id}`);
  return res.data.data;
}

export async function listDimensionOptions(dimensionId) {
  const res = await api.get(`/variant-dimensions/${dimensionId}/options`);
  return res.data.data.items;
}

export async function createDimensionOption(dimensionId, payload) {
  const res = await api.post(`/variant-dimensions/${dimensionId}/options`, payload);
  return res.data.data;
}

export async function updateDimensionOption(dimensionId, optionId, payload) {
  const res = await api.put(`/variant-dimensions/${dimensionId}/options/${optionId}`, payload);
  return res.data.data;
}

export async function deleteDimensionOption(dimensionId, optionId) {
  const res = await api.delete(`/variant-dimensions/${dimensionId}/options/${optionId}`);
  return res.data.data;
}

export async function validateVariantsImport(rows) {
  const res = await api.post("/variant-dimensions/import/validate", { rows });
  return res.data.data;
}

export async function importVariants(rows) {
  const res = await api.post("/variant-dimensions/import", { rows });
  return res.data.data;
}

